var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5807 0H1.68751C1.27479 0 0.878975 0.164725 0.587138 0.457936C0.2953 0.751148 0.131348 1.14883 0.131348 1.56349V20.3254C0.131348 20.7401 0.2953 21.1377 0.587138 21.431C0.878975 21.7242 1.27479 21.8889 1.68751 21.8889H12.5807C12.9934 21.8889 13.3892 21.7242 13.681 21.431C13.9729 21.1377 14.1368 20.7401 14.1368 20.3254V1.56349C14.1368 1.14883 13.9729 0.751148 13.681 0.457936C13.3892 0.164725 12.9934 0 12.5807 0ZM7.91216 20.3254H6.356V18.7619H7.91216V20.3254ZM1.68751 17.1984V1.56349H12.5807V17.1984H1.68751Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMoney);
export default __webpack_public_path__ + "static/media/mobile_money.d6f903247bcc52f4af02abc65689e575.svg";
export { ForwardRef as ReactComponent };